declare namespace $ {

	export class $shm_hitalama_docs extends $shm_hitalama_textbook {
		menu_title( ): string
	}
	
}

//# sourceMappingURL=docs.view.tree.d.ts.map